import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
      style={{ backgroundColor: isScrolled ? 'rgba(245, 233, 208, 0.95)' : 'transparent' }}
    >
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_leaf-lounge-3/artifacts/kbshdl1e_file_00000000646471fdbb03789bab2f6e30.png" 
              alt="Mudbutt Brew"
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('products')}
              className="text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Our Brews
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Our Story
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              FAQ
            </button>
            <Link
              to="/accessories"
              className="text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
              data-testid="nav-accessories"
            >
              Shop Gear
            </Link>
            <Button
              onClick={() => scrollToSection('contact')}
              className="font-semibold"
              style={{ backgroundColor: '#8b5c2f', color: '#f5e9d0' }}
            >
              Get in Touch
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{ color: '#8b5c2f' }}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('products')}
              className="text-left text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Our Brews
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-left text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-left text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              Our Story
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-left text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
            >
              FAQ
            </button>
            <Link
              to="/accessories"
              className="text-left text-base font-semibold hover:opacity-70 transition-opacity"
              style={{ color: '#5e3a1c' }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Shop Gear
            </Link>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full font-semibold"
              style={{ backgroundColor: '#8b5c2f', color: '#f5e9d0' }}
            >
              Get in Touch
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};
